import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpService } from '../../shares/services/http.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InvoiceComponent implements OnInit {

  uuid: any;
  quotation_id: any;
  print: boolean = false;
  action: string = "";
  pageMax: number = 21;
  lengthNumber: number = 0;
  constructor(private http: HttpService,
    private activatedRoute: ActivatedRoute) {
    // this.http.Authorization = this.activatedRoute.snapshot.params['uuid'];
    // console.log(this.http.Authorization);

    this.quotation_id = this.activatedRoute.snapshot.params['uuid'];
    this.action = this.activatedRoute.snapshot.params['status'];
  }
  reportItems: any = [];
  viewItems: any = [];
  pushItems: any = [];
  ngOnInit(): void {
    this.getQuotation();
    // this.getHeight();

  }

  ngAfterViewInit() {

  }

  quotationItems: any;
  modelItems: any = [];
  payment_images: any;
  compenyItems: any;
  contactItems: any;
  expire_date: boolean = false;
  date: boolean = false;
  model: any;
  numberRow: number = 0;
  disAmount: any = 0
  getQuotation() {

    this.http.methodGet(`api/MSBilling/invoice/view/${this.quotation_id}`).subscribe((res: any) => {
      if (res.data.expire_date) {
        this.expire_date = moment(res.data.expire_date) < moment(new Date())
        this.date = res.data.expire_date
      }
      this.quotationItems = res.data;
      if (this.quotationItems.vat_type != 'N' && this.quotationItems.discount_amount > 0) this.numberRow = 4;
      if (this.quotationItems.vat_type == 'N' || this.quotationItems.discount_amount == 0) this.numberRow = 3;
      if (this.quotationItems.vat_type == 'N' && this.quotationItems.discount_amount == 0) this.numberRow = 2;

      if (this.quotationItems) {
        this.reportItems = this.quotationItems.products;
        this.contactItems = this.quotationItems.contact_customer;
        this.compenyItems = this.quotationItems.contact_sale;
        // let dis: any;W
        if (this.quotationItems.discount_type == 'P') {
          this.disAmount = this.quotationItems.price_sub_total / 100 * Number(this.quotationItems.discount_amount)
          this.quotationItems.price_net_total = this.quotationItems.price_sub_total - this.disAmount
        }
        else this.quotationItems.price_net_total = this.quotationItems.price_sub_total - this.quotationItems.discount_amount

        this.compenyItems.contact_img_path = `${environment.images}/${this.compenyItems.contact_img_path}`;
        this.payment_images = this.quotationItems.payment_method_img_path = `${environment.images}/${this.quotationItems.payment_method_img_path}`;
        this.model = {
          quotationItems: this.quotationItems,
          contactItems: this.contactItems,
          compenyItems: this.compenyItems,
          h_status: 2
        }

        // รอบแรก render ทุกแถวเพื่อวัดความสูงจริง (2 หน้า: ไม่มี/มี ท้ายเอกสาร) แล้วค่อยแบ่งหน้า
        this.reportItems = this.reportItems || [];
        this.reportItems.forEach((f: any, i: number) => f.id = i + 1);
        this.measuring = true;
        this.viewItems = [
          { page: 1, items: this.reportItems, footer: false },
          { page: 2, items: this.reportItems, footer: true }
        ];

        setTimeout(() => {
          this.getHeight();
          this.measuring = false;
          // print
          if (this.action == 'print') setTimeout(() => this.printf(), 500);
        }, 500);
      }
    })
  }

  max: any = 0;
  footer: any = 0;
  rowSpace: number = 0;
  lastSpace: number = 0;
  measuring: boolean = true;
  // เผื่อความสูงไว้เล็กน้อย เพราะความกว้างคอลัมน์ของแต่ละหน้าอาจไม่เท่ากันพอดี
  safeSpace: number = 12;
  // ถ้าที่ว่างเหลือน้อยกว่านี้ ไม่ต้องตัดมาใส่ (กันเศษบรรทัดเดียวค้างท้ายหน้า)
  minSplit: number = 45;
  // ฟิลด์รายละเอียดที่ตัดข้ามหน้าได้ ('' = ตัดไม่ได้)
  descField: string = 'product_description';
  // เอกสารบางแบบแสดงท้ายตาราง (ยอดรวม/ท้ายเอกสาร) ทุกหน้า
  footerEveryPage: boolean = false;

  // แบ่งหน้าจากความสูงจริงของแต่ละแถว ถ้าแถวไหนยาวเกินพื้นที่ที่เหลือ จะตัดรายละเอียดไปต่อหน้าถัดไป
  //
  // รอบวัดความสูงจะ render 2 หน้า เพราะความกว้างคอลัมน์ไม่เท่ากัน
  //   หน้า A = เฉพาะแถวสินค้า  -> ใช้กับหน้าที่ไม่มีท้ายเอกสาร
  //   หน้า B = แถวสินค้า + ท้ายเอกสาร -> ใช้ตัดสินว่าท้ายเอกสารลงหน้าสุดท้ายได้ไหม
  getHeight() {
    const content: any = document.querySelector('.content');
    const all: any = document.querySelectorAll('.sub-content');
    if (!content) return;
    const heads: any = document.querySelectorAll('.headers');
    const footer: any = document.querySelector('.footer');
    this.max = content.clientHeight;
    this.footer = footer ? footer.getBoundingClientRect().height : 0;

    const total = Math.min(all.length, (this.reportItems || []).length);
    const headA: number = heads[0] ? heads[0].getBoundingClientRect().height : 0;
    const headB: number = heads[1] ? heads[1].getBoundingClientRect().height : headA;

    // ความสูงของแต่ละแถวในหน้า A และหน้า B
    const rows: any = [];
    const rowsB: any = [];
    for (let i = 0; i < total; i++) {
      rows.push(all[i]);
      rowsB.push(all[total + i] || all[i]);
    }

    // ท้ายตารางที่แสดงทุกหน้า ต้องกันที่ว่างไว้ทุกหน้า
    let repeat = 0;
    if (this.footerEveryPage && total > 0) {
      const table: any = rowsB[0].closest('table');
      let sum = 0;
      for (let i = 0; i < total; i++) sum += rowsB[i].getBoundingClientRect().height;
      repeat = table ? table.getBoundingClientRect().height - headB - sum : this.footer;
    }

    this.rowSpace = this.max - (this.footerEveryPage ? headB + repeat : headA) - this.safeSpace;
    this.lastSpace = this.max - headB - this.safeSpace;

    const pages: any = [];
    let items: any = [];
    let used: number = 0;
    let usedLast: number = 0;

    for (let i = 0; i < total; i++) {
      const base: any = this.footerEveryPage ? rowsB[i] : rows[i];
      let item: any = { ...this.reportItems[i], id: i + 1 };
      let height: number = base.getBoundingClientRect().height;
      // สัดส่วนความสูงเมื่ออยู่หน้าเดียวกับท้ายเอกสาร (คอลัมน์แคบลง แถวจะสูงขึ้น)
      const ratio: number = height > 0 ? rowsB[i].getBoundingClientRect().height / height : 1;
      this.buildMeasureRow(base);

      while (item) {
        const remain = this.rowSpace - used;

        // ลงหน้านี้ได้ทั้งแถว
        if (height <= remain) {
          items.push(item);
          used += height;
          usedLast += height * ratio;
          break;
        }

        // ยาวเกินพื้นที่ที่เหลือ -> ตัดรายละเอียดเท่าที่ลงได้ ส่วนที่เหลือไปต่อหน้าถัดไป
        const split = remain >= this.minSplit ? this.splitItem(item, remain) : null;
        if (split) {
          items.push(split.head);
          pages.push({ page: pages.length + 1, items: items, footer: false });
          items = [];
          used = 0;
          usedLast = 0;
          item = split.rest;
          height = split.restHeight;
          continue;
        }

        // ตัดไม่ได้ (ที่เหลือน้อยเกินไป หรือมีบรรทัดเดียว) -> ขึ้นหน้าใหม่
        if (used > 0) {
          pages.push({ page: pages.length + 1, items: items, footer: false });
          items = [];
          used = 0;
          usedLast = 0;
          continue;
        }
        items.push(item);
        used += height;
        usedLast += height * ratio;
        break;
      }
    }
    this.destroyMeasureRow();

    this.endPage(pages, items, usedLast);
  }

  // หน้าสุดท้าย: ถ้าท้ายเอกสารไม่พอในหน้านี้ ให้ยกไปหน้าใหม่
  endPage(pages: any, items: any, used: number) {
    if (this.footerEveryPage) {
      if (items.length > 0 || pages.length == 0) pages.push({ page: pages.length + 1, items: items, footer: true });
    }
    else if (used + this.footer <= this.lastSpace) {
      pages.push({ page: pages.length + 1, items: items, footer: true });
    }
    else {
      if (items.length > 0) pages.push({ page: pages.length + 1, items: items, footer: false });
      pages.push({ page: pages.length + 1, items: [], footer: true });
    }
    this.viewItems = pages;
  }

  // ตัดรายละเอียดของแถวให้พอดีกับพื้นที่ที่เหลือ (ตัดทีละบรรทัด)
  splitItem(item: any, space: number) {
    if (!this.measureRow || !this.descField) return null;
    const text: string = String(item[this.descField] || '');
    const lines: any = text.split('\n');
    if (lines.length < 2) return null;

    let fit = 0;
    let low = 1;
    let high = lines.length - 1;
    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      const height = this.measureItem(lines.slice(0, mid).join('\n'), !item.continued);
      if (height <= space) {
        fit = mid;
        low = mid + 1;
      }
      else high = mid - 1;
    }
    if (fit == 0) return null;

    const head: any = { ...item };
    head[this.descField] = lines.slice(0, fit).join('\n');

    // แถวต่อเนื่อง: เหลือไว้เฉพาะรายละเอียดส่วนที่ยังไม่ได้แสดง
    const rest: any = {};
    Object.keys(item).forEach((k: string) => rest[k] = null);
    rest[this.descField] = lines.slice(fit).join('\n');
    rest.continued = true;

    return { head: head, rest: rest, restHeight: this.measureItem(rest[this.descField], false) };
  }

  measureBox: any;
  measureRow: any;
  measureText: any = [];

  // clone แถวจริงไว้นอกจอ สำหรับวัดความสูงตอนลองตัดข้อความ
  buildMeasureRow(row: any) {
    this.destroyMeasureRow();
    const table: any = row.closest('table');
    if (!table || !this.descField || !row.querySelector('.p-desc')) return;

    const box: any = document.createElement('div');
    box.style.cssText = 'position:absolute;left:-10000px;top:0;visibility:hidden;';

    const content: any = document.createElement('div');
    content.className = 'content';
    content.style.cssText = 'min-height:0;max-height:none;';

    const clone: any = table.cloneNode(false);
    clone.style.tableLayout = 'fixed';
    clone.style.width = `${table.getBoundingClientRect().width}px`;

    const tbody: any = document.createElement('tbody');
    const tr: any = row.cloneNode(true);
    this.measureText = [];
    for (let i = 0; i < row.cells.length; i++) {
      tr.cells[i].style.width = `${row.cells[i].getBoundingClientRect().width}px`;
      this.measureText.push(row.cells[i].textContent);
    }

    tbody.appendChild(tr);
    clone.appendChild(tbody);
    content.appendChild(clone);
    box.appendChild(content);
    document.body.appendChild(box);

    this.measureBox = box;
    this.measureRow = tr;
  }

  destroyMeasureRow() {
    if (this.measureBox && this.measureBox.parentNode) this.measureBox.parentNode.removeChild(this.measureBox);
    this.measureBox = null;
    this.measureRow = null;
  }

  // ความสูงของแถวเมื่อใส่รายละเอียดเท่าที่กำหนด (head = แถวแรกของสินค้า, ไม่ใช่ head = แถวต่อเนื่อง)
  measureItem(desc: string, head: boolean): number {
    const row: any = this.measureRow;
    if (!row) return 0;

    const detail: any = row.querySelector('.detail');
    for (let i = 0; i < row.cells.length; i++) {
      if (row.cells[i] == detail) continue;
      row.cells[i].textContent = head ? this.measureText[i] : '';
    }

    const name: any = row.querySelector('.p-name');
    if (name) name.style.display = head ? '' : 'none';

    const text: any = row.querySelector('.p-desc');
    if (text) {
      text.style.display = desc ? '' : 'none';
      text.textContent = desc;
    }
    return row.getBoundingClientRect().height;
  }

  printf() {
    window.print();
    this.action = ""
  }
}